<template>
  <sixteen-wide-column>
    <pre>{{ json }}</pre>
  </sixteen-wide-column>
</template>

<script>
import SixteenWideColumn from './utility/EightWideColumn'
export default {
  name: 'JsonOutput',
  components: { SixteenWideColumn },
  props: {
    json: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
